"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onViewingKeyReady = exports.onViewingKeyCreated = void 0;
var index_1 = require("./index");
function onViewingKeyCreated(callback) {
    index_1.subscribeEvent('viewing-key-created', callback);
}
exports.onViewingKeyCreated = onViewingKeyCreated;
function onViewingKeyReady(callback) {
    index_1.subscribeEvent('viewing-key-ready', callback);
}
exports.onViewingKeyReady = onViewingKeyReady;
//# sourceMappingURL=viewing-keys.js.map